import { DEFAULT_COUNTRY_RISK_RATINGS } from "./defaultCountryRiskRatings";

export { DEFAULT_COUNTRY_RISK_RATINGS };

export const COUNTRY_RISK_CATEGORIES = [
  {
    rating: "SANCTIONED_COMPREHENSIVE",
    label: "Sanctioned (Comprehensively)",
    score: 1000,
    level: "Unacceptable",
  },
  {
    rating: "SANCTIONED_TARGETED",
    label: "Sanctioned (Targeted/Sectoral)",
    score: 20,
    level: "High",
  },
  {
    rating: "HIGH",
    label: "High Risk Country",
    score: 10,
    level: "Medium",
  },
  {
    rating: "MEDIUM",
    label: "Medium Risk Country",
    score: 0,
    level: "Low",
  },
  {
    rating: "LOW",
    label: "Low Risk Country",
    score: 0,
    level: "Low",
  },
];

const PASS_RISK_LEVELS = new Set(["Low", "Medium"]);

export const COUNTRY_RISK_LEVEL_COLOR = {
  Unacceptable: "red",
  High: "orange",
  Medium: "yellow",
  Low: "green",
};

export const COUNTRY_RISK_RATING_OPTIONS = COUNTRY_RISK_CATEGORIES.map(
  (category) => ({
    value: category.rating,
    label: category.label,
  })
);

export const categorizeCountryRisk = (rating) =>
  COUNTRY_RISK_CATEGORIES.find((category) => category.rating === rating) ||
  null;

export const formatRiskScore = (score, t = (value) => value) => {
  const points = Number(score);
  const formatted = points.toLocaleString("en-US");
  const unit = points === 0 || points === 1 ? t("point") : t("points");
  return `${formatted} ${unit}`;
};

export const normalizeCountryRiskRatings = (rows) => {
  const seen = new Set();
  const normalized = [];

  for (const row of rows || []) {
    const country = String(row?.country || "").trim();
    const category = categorizeCountryRisk(row?.rating);
    if (!country || !category) continue;

    const key = country.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    normalized.push({ country, rating: category.rating });
  }

  if (!normalized.length) {
    return DEFAULT_COUNTRY_RISK_RATINGS.map((row) => ({ ...row }));
  }

  return normalized.sort((a, b) => a.country.localeCompare(b.country));
};

export const validateCountryRiskRatings = (rows) => {
  const seen = new Set();

  for (const row of rows || []) {
    const country = String(row?.country || "").trim();
    if (!country) return "Country is required";
    if (!categorizeCountryRisk(row?.rating)) return "Rating is required";

    const key = country.toLowerCase();
    if (seen.has(key)) return `Duplicate country: ${country}`;
    seen.add(key);
  }

  return null;
};

export const screenCountryRisk = (rows, country) => {
  const name = String(country || "").trim();
  if (!name) return { status: "EMPTY" };

  const row = (rows || []).find(
    (item) => String(item?.country || "").trim().toLowerCase() === name.toLowerCase()
  );
  const category = row ? categorizeCountryRisk(row.rating) : null;
  if (!category) return { status: "NOT_LISTED", country: name };

  return {
    status: PASS_RISK_LEVELS.has(category.level) ? "PASS" : "FURTHER_HANDLING",
    country: name,
    rating: category.rating,
    label: category.label,
    score: category.score,
    level: category.level,
  };
};

export const countryScreeningRank = (screening) => {
  const score = Number(screening?.score);
  const points = Number.isFinite(score) ? score : 0;
  if (screening?.status === "FURTHER_HANDLING") return 3000 + points;
  if (screening?.status === "NOT_LISTED") return 2000;
  if (screening?.status === "PASS") return 1000 + points;
  return 0;
};
